import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import api from "../core/api"
import { removerAcentos } from "../core/utils"

import TrContrato from "../components/TrContrato"
import Back from "../components/Back"

class Contratos extends React.Component {
    state = {
        totalPorPagina: 20,
        page: 1,
        carregando: false,
        contratos: [],
        data: []
    }

    componentDidMount() {
        this.setState({ carregando: true })
        api.get("/contratos").then(response => {
            let contratos = response.data.contratos
            this.setState({ contratos, data: response.data.contratos, carregando: false })
        })
    }

    filterContratos(e) {
        console.log(e.target.value)
        let endereco = e.target.value
        const newData = this.state.data.filter(item => {
            let itemData = removerAcentos(item.imovel.endereco.toLowerCase())
            let textData = removerAcentos(endereco.toLowerCase())
            return itemData.indexOf(textData) > -1
        })
        this.setState({ contratos: newData })
    }

    renderContratos() {
        let { contratos, page, totalPorPagina } = this.state
        let data = []
        if (page === 1) {
            data = contratos.slice(0, totalPorPagina)
        } else {
            let init = page * totalPorPagina - totalPorPagina
            let end = init + totalPorPagina
            data = contratos.slice(init, end)
        }
        if (this.state.carregando) {
            return (
                <tr>
                    <td colspan="6">Carregando...</td>
                </tr>
            )
        } else {
            return data.map(item => {
                return <TrContrato key={`contrrato_${item.id}`} contrato={item} />
            })
        }
    }

    renderPaginate = () => {
        let butons = []
        let { totalPorPagina, page, contratos } = this.state
        let total = contratos.length
        if (total > 0) {
            let lk = Math.ceil(total / totalPorPagina)
            console.log(total, totalPorPagina, lk)
            for (let i = 1; i <= lk; i++) {
                let isCurrent = i === page ? "is-current" : ""
                butons.push(
                    <li key={`page_${i}`}>
                        <button
                            onClick={() => this.setState({ page: i })}
                            className={`pagination-link ${isCurrent}`}
                            aria-label={`Goto page ${i}`}
                        >
                            {i}
                        </button>
                    </li>
                )
            }
            return butons
        }
    }

    render() {
        return (
            <section className="section">
                <div className="container content">
                    <div className="card">
                        <header className="card-header content-header">
                            <Back />
                            <h3 className="title is-5 nomargin">Listagem de Contratos</h3>
                        </header>
                        <div className="card-content">
                            <div className="content">
                                <div className="card-info">
                                    <div className="form-filtro">
                                        <label>Endreço do Imóvel: </label>&nbsp;
                                        <input
                                            className="input"
                                            onChange={e => this.filterContratos(e)}
                                            style={{ width: 400 }}
                                            type="text"
                                            placeholder="Busque pelo endereço do imóvel"
                                        />
                                    </div>
                                </div>
                                <table className="table is-striped">
                                    <thead>
                                        <tr>
                                            <th>Código</th>
                                            <th>Endereço do Imóvel</th>
                                            <th>Vigência</th>
                                            <th>Status</th>
                                            <th>Participação</th>
                                            <th>Link</th>
                                        </tr>
                                    </thead>
                                    <tbody>{this.renderContratos()}</tbody>
                                </table>
                                <nav
                                    className="pagination"
                                    role="navigation"
                                    aria-label="pagination"
                                >
                                    <ul className="pagination-list">{this.renderPaginate()}</ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    app: state.app
})

export default withRouter(connect(mapStateToProps)(Contratos))
